import axios from 'axios';

import api from 'services/api/api';

export const getProperties = () => api.get('/api/v1/properties');

export const getPropertiesFallback = () =>
  axios
    .create({
      baseURL: '',
    })
    .get('/rewards/properties.json');
